<section [formGroup]="loan.form" fxLayout="column" fxLayoutGap="8px">

  <mat-form-field>
    <input matInput placeholder="Loan amount requested" required formControlName="target_loan_amount" type="number" step="5000">
    <mat-error *ngIf="loan.form.get('target_loan_amount').hasError('required')">Required.</mat-error>
    <mat-error *ngIf="loan.form.get('target_loan_amount').hasError('range')">Invalid amount.</mat-error>
    <mat-error *ngIf="loan.form.get('target_loan_amount').hasError('increment')">Invalid amount.</mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-select placeholder="Loan term" required formControlName="target_loan_duration">
      <mat-option *ngFor="let duration of durations|async" [value]="duration">
        {{ duration }} months
      </mat-option>
    </mat-select>
    <mat-error *ngIf="loan.form.get('target_loan_duration').hasError('required')">Required.</mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>Loan purpose</mat-label>
    <textarea matInput placeholder="Type your reason for the loan"
              required formControlName="loan_purpose" matTextareaAutosize></textarea>
    <mat-error *ngIf="loan.form.get('loan_purpose').hasError('required')">Required.</mat-error>
  </mat-form-field>

  <bb-co-maker></bb-co-maker>
</section>
